import React from "react";
import ReactDOM from "react-dom/client";
import "../index.css";
import App from "./App";
import { AppProvider } from "@/shared/providers/app-provider";
import { UIProvider } from "@hk-process-innovation-and-consulting/mira-ui-react";
import { configureCognito } from "@/modules/auth/cognito";
import { cognitoAuthService } from "@/modules/auth/services/cognitoAuthService";
import { authStorageService } from "@/modules/auth/services/authStorageService";

configureCognito();

async function bootstrapAuthSession(): Promise<void> {
  // After a 401/forced logout, do not rehydrate Cognito into localStorage
  // or PublicRoute will bounce back to /dashboard and loop.
  if (authStorageService.consumeForceLogout()) {
    await cognitoAuthService.signOut();
    authStorageService.clear();
    return;
  }

  const session = await cognitoAuthService.restoreSession();
  if (session) {
    authStorageService.setToken(session.idToken);
    authStorageService.setUser(session.user);
  }
}

void bootstrapAuthSession();

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <UIProvider>
      <AppProvider>
        <App />
      </AppProvider>
    </UIProvider>
  </React.StrictMode>
);
